"use client";

import { loading } from "@/lib/features/hotel/hotelSlice";
import { useAppSelector } from "@/lib/hooks";
import { useCallback } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Import skeleton CSS
// Define prop types using the Filter value type for meal_plan
interface MealPlanFilterProps {
  onChange: (value: string[]) => void;
  data: { label: string; value: string }[];
  value: string[];
}

const MealPlanFilter = ({ onChange, data, value }: MealPlanFilterProps) => {
  const isLoading = useAppSelector(loading);

  const handleCheckboxChange = useCallback((checkboxValue: string) => {
    const newValues = value.includes(checkboxValue)
      ? value.filter((val: string) => val !== checkboxValue)
      : [...value, checkboxValue];
    onChange(newValues);
  }, [value, onChange]);

  return (
    <>
      {isLoading ? (
        // Skeleton loader when isLoading is true
        Array(6).fill(0).map((_, index) => (
          <div className="col-12 mb-2" key={index}>
           
            <div className="form-checkbox d-flex items-center">
            <input
                name="meal_plan"
                type="checkbox"
                disabled={true}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10"><Skeleton width={250} height={15} /></div>
            </div>
          </div>
        ))
      ) : (
        // Normal checkbox display when not loading
        data?.map((item: any, index: number) => (
          <div className="col-12" key={index}>
            <div className="form-checkbox d-flex items-center">
              <input
                name="meal_plan"
                type="checkbox"
                value={item.value}
                checked={value.includes(item.value)}
                onChange={(e) => handleCheckboxChange(e.target.value)}
                disabled={isLoading}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">{item.label}</div>
            </div>
          </div>
        ))
      )}
    </>
  );
};

export default MealPlanFilter;